export interface ModalDiscardProps {
  children?: ({
    onClose,
    onConfirm,
  }: Pick<
    ModalDiscardProps,
    'onClose' | 'onConfirm' | 'open'
  >) => React.ReactNode;
  onConfirm?: () => void;
  onClose?: () => void;
  open?: boolean;
}
export const ModalDiscard = ({
  children,
  onClose,
  onConfirm,
  open,
}: ModalDiscardProps) => {
  return open && children?.({ onClose, onConfirm, open });
};

export default ModalDiscard;
